import { useMemo } from "react";
import { IStyleSet, mergeStyleSets } from "@fluentui/react/lib/Styling";

const classNames = {
  root: `ValueWithTooltipRoot`,
  list: `ValueWithTooltipList`
};

export function useValueWithTooltipStyles(styleSet: IStyleSet) {
  return useMemo(
    () => mergeStyleSets(
      {
        root: [
          classNames.root,
          {
            height: `100%`,
            overflow: `hidden`,
            width: `100%`
          }
        ],
        list: [
          classNames.list,
          {
            listStyle: `none`,
            margin: 0,
            padding: 0
          }
        ]
      },
      styleSet
    ),
    [styleSet]
  );
}
